import React, {useState} from "react";
import Api from "../../../Api/api";
import {toast} from "react-toastify";

const AdminEditProzessOptionsTable = ({optValue, optID, index, getData}) => {

    const [loading, setLoading] = useState(false)
    const [optionValueEdit, setOptionValueEdit] = useState(false)
    const [optionValue, setOptionValue] = useState(optValue)

    function save() {
        setLoading(true)
        let data = new FormData
        data.append('optID', optID)
        data.append('optValue', optionValue)

        Api().post(`/sp_updateProcessOption`, data).then(res => {
                toast.success('Update erfolgreich')
                setOptionValueEdit(false)
                setLoading(false)
            }
        ).catch(e => {
            toast.error('Update konnte nicht durchgeführt werden!')
            setLoading(false)
        })
    }

    function deleteOption() {
        if (window.confirm('Möchten Sie diese Option wirklich löschen?')) {
            setLoading(true)
            let data = new FormData
            data.append('optID', optID)

            Api().post(`/sp_deleteProcessOption`, data).then(res => {
                    toast.success('Option wurde erfolgreich gelöscht')
                    getData()
                    setLoading(false)
                }
            ).catch(e => {
                toast.error('Löschen konnte nicht durchgeführt werden!')
                setLoading(false)
            })
        }
    }

    return (
        <tbody>
        <tr className={index % 2 === 1 ? 'bg-white' : 'bg-offWhite'}>
            <td className="pl-1.5">{optID}</td>
            <td style={{textTransform: 'none',color:optionValue?'#1c1c1c': '#a6a6a6'}} onClick={() => setOptionValueEdit(true)}>
                {
                    !optionValueEdit && optionValue? optionValue :!optionValueEdit && 'Hier ist noch eine leere Option'
                }
                {
                    optionValueEdit &&
                    <input value={optionValue}
                              style={{width: '100%', backgroundColor: 'whitesmoke', padding: '10px 5px'}}
                              onChange={(e) => setOptionValue(e.target.value)}
                              placeholder='Option Wert'/>
                }
            </td>
            <td className="text-right pr-4">
                <div className="flex gap-2 justify-end">
                    <button
                        className='px-3 py-1 bg-mainBlue text-white rounded rounded-md'
                        onClick={save}
                        disabled={loading}
                    >
                        {loading ? 'speichere...' : 'Speichern'}
                    </button>
                    <button
                        className='px-3 py-1 bg-cancel text-white rounded rounded-md hover:bg-red'
                        onClick={deleteOption}
                        disabled={loading}
                    >
                        Löschen
                    </button>
                </div>
            </td>
        </tr>
        </tbody>
    )
}

export default AdminEditProzessOptionsTable
